import { map } from 'rxjs/operators';
import { HttpInterceptor, HttpEvent, HttpHandler, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';

export class DateInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      map(event => {
        if (event instanceof HttpResponse) {
          const body = event.body;
          this.processObject(body);
          return event.clone({ body });
        }
        return event;
      })
    );
  }

  // Note: This runs before Angular's default string to date conversion
  // so we don't need to check for objects that are dates.
  processObject(body: any): void {
    if (typeof body === 'object' && body !== null && body !== undefined) {
      for (var key in body) {
        if (body[key] === null || body[key] === undefined || this.shouldSkipKey(key)) {
          // Avoid processing these values. 
          // Name and email are specified to avoid treating a user-provided value as a date. 
          continue;
        }
        if (typeof body[key] === 'string') {
          if (this.isValidDate(body[key])) {
            body[key] = this.processDate(body[key]);
          }
        } else if (typeof body[key] === 'object') {
          this.processObject(body[key]);
        }
      }
    }
  }

  // It's quite an edge case but skip date-checking for user-provided values like names just to be sure.
  // If in the future we have any internal non-date values that match our datetime structure add them here.
  shouldSkipKey(key: string): boolean {
    let upperKey = key.toUpperCase();
    return upperKey === "NAME" || upperKey === "EMAIL" || upperKey === "EXTERNALID";
  }

  processDate(value: string): Date | undefined {
    const timezoneRegex = /\+\d\d:\d\d|\-\d\d:\d\d/;
    if (value === null || value === undefined) {
      return undefined;
    } else if (value.includes('Z') || timezoneRegex.test(value)) {
      // This contains timezone data so it's fine as-is. 
      return new Date(value);
    } else {
      // TypeScript assumes local time when timezone is not specified so this time is off.
      let date = new Date(value);
      // getTimezoneOffset is positive for negative offsets and negative for positive offsets.
      // So to convert a UTC-as-local time to true-local time we subtract the getTimezoneOffset instead of adding it.
      date.setMinutes(date.getMinutes() - date.getTimezoneOffset());
      return date;
    }
  }
  
  isValidDate(value: string) : boolean {
    // This only matches dates with times as returned by our backend.
    // We don't want to modify dates without times. 
    const dateTimeRegexWithT = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d{3})?$/;
    const dateTimeRegexWithSpace = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}(\.\d{3})?$/;
    let isValid = dateTimeRegexWithT.test(value) || dateTimeRegexWithSpace.test(value);
    return isValid;
  }
}